import firebase from 'firebase/app'
import 'firebase/database'

export const DEFAULT_PUBLIC_SETTINGS = {
  line_at: '@fifa.v1',
  line_url: 'https://lin.ee/XdHH2II7'
}

export async function getPublicSettings () {
  try {
    const data = (await firebase.database().ref('/settings/public').once('value')).val()
    return Object.assign({}, DEFAULT_PUBLIC_SETTINGS, data || {})
  } catch (error) {
    return Object.assign({}, DEFAULT_PUBLIC_SETTINGS)
  }
}

export function getLineAtText (settings) {
  return (settings && settings.line_at) || DEFAULT_PUBLIC_SETTINGS.line_at
}

export function getLineUrl (settings) {
  return (settings && settings.line_url) || DEFAULT_PUBLIC_SETTINGS.line_url
}
